export const whyUseEnhancement = [
	{
		icon: '✅',
		title: 'whyUseData_title1',
		subtitle: 'whyUseData_subtitle1',
	},
	{
		icon: '✅',
		title: 'whyUseData_title2',
		subtitle: 'whyUseData_subtitle2',
	},
	{
		icon: '✅',
		title: 'whyUseData_title3',
		subtitle: 'whyUseData_subtitle3',
	},
	{
		icon: '✅',
		title: 'whyUseData_title4',
		subtitle: 'whyUseData_subtitle4',
	},
];
